import { useState } from 'react';
import { useQuery } from 'react-query';
import { Megaphone, X } from 'lucide-react';
import { apiClient } from '@/lib/api-client';

export default function AnnouncementBanner() {
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem('announcement_dismissed') ?? '';
  });

  const { data } = useQuery('active-announcement',
    () => apiClient.get<any>('/announcements/active').catch(() => null),
    { staleTime: 5 * 60 * 1000 }
  );

  const announcement = data?.announcement;

  if (!announcement || dismissed === announcement.id) return null;

  const dismiss = () => {
    localStorage.setItem('announcement_dismissed', announcement.id);
    setDismissed(announcement.id);
  };

  return (
    <div className="bg-brand-600 text-white px-4 py-3">
      <div className="max-w-5xl mx-auto flex items-center gap-3">
        <Megaphone className="h-4 w-4 flex-shrink-0 opacity-80" />
        <div className="flex-1 min-w-0">
          <span className="font-semibold mr-2">{announcement.title}</span>
          <span className="text-brand-100 text-sm">{announcement.content}</span>
        </div>
        <button onClick={dismiss} className="flex-shrink-0 p-1 rounded hover:bg-brand-500 transition-colors" aria-label="Dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
